const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/capacity/orphaned-data/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18next from 'i18next';
export const Route = createFileRoute('/(app)/org/$org/settings/capacity/orphaned-data/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18next.t($ => $.common.settings.capacity.orphanedData.title)
  }),
  staticData: {
    topNav: {
      title: i18next.t($ => $.common.settings.capacity.orphanedData.title)
    }
  }
});